import React from 'react'
import { ICONS, Confirm } from '../../../components'
import * as ReactBootstrap from 'react-bootstrap'
import InviteCustomerFormPane from './InviteCustomerFormPane'
import * as rest from '../../../services'
import { showErrorToast, showSuccessToast } from '../../../state/toasts'
import {useDispatch} from "react-redux";
export const Token = ({ token, onInvite,onClose }) => {
    console.table(token)
  const {
    first_name,
    token_number,
    last_name,
    contact_number,
    can_invite,
    category,
    email,
    distance_from_organization,
    has_customer_left,
    customer_closed_on,is_current
  } = token
  const dispatch = useDispatch()
  const resendTokenInformation = async () => {
    const { url } = token
   await rest.RestService.call_url_action(
      `${url}resend_token_number_by_sms/`,
      'GET'
    )
  }

  const markCustomerLeft= async () => {
    const { url } = token
   await rest.RestService.call_url_action(
      `${url}mark_customer_left/`,
      'POST'
    )
      dispatch(showSuccessToast('Marked Customer Left', 'Marked Customer Left centre.'))

  }

  const markClose= async () => {
    const { url } = token
   await rest.RestService.call_url_action(
      `${url}mark_close/`,
      'POST'
    )
      onClose && onClose()
      dispatch(showSuccessToast('Marked Customer Closed', 'Marked Customer Closed.'))

  }
  const actionFormatter = () => {
    if (can_invite) {
      return (
        <div onClick={(e) => e.stopPropagation()}>
          <ReactBootstrap.Dropdown id={'token-dropdown'}>
            <ReactBootstrap.Dropdown.Toggle
    variant="dark"
    size="sm"
    />
            <ReactBootstrap.Dropdown.Menu>
              <InviteCustomerFormPane
    onInvite={onInvite}
    token={token}
    />
              <Confirm
                onConfirm={resendTokenInformation}
                body="Are you sure you want to resend token information?"
                confirmText="Send"
                confirmBSStyle="danger"
                title="Confirm Resend token information"
              >
                <ReactBootstrap.Dropdown.Item variant="dark" eventKey="1">
                  {ICONS.SMS} Resend token information
                </ReactBootstrap.Dropdown.Item>
              </Confirm>


                <Confirm
                onConfirm={markCustomerLeft}
                body="Are you sure you want to Mark customer left?"
                confirmText="Send"
                confirmBSStyle="danger"
                title="Confirm Customer Left"
              >
                <ReactBootstrap.Dropdown.Item variant="dark" eventKey="1">
                  {ICONS.LOG} Customer Did not show up
                </ReactBootstrap.Dropdown.Item>
              </Confirm>

            </ReactBootstrap.Dropdown.Menu>
          </ReactBootstrap.Dropdown>
        </div>
      )
    }
  }
  return (
    <ReactBootstrap.Row className="border-bottom border-dark">
      <ReactBootstrap.Col className="pl-3" xs={11}>
        <p className="h3">
          <table>
            <tr>
              <td style={{ display: 'block' }}>
                <h1 className={'mt-2 mr-2'}>{token_number}</h1>
              </td>
              <td>
                <div className="p-2">
                    {first_name} {last_name}
                    <p className="h5">{has_customer_left?<span style={{
                        color:'red'
                    }} >Customer Left</span>:""}</p>
                     <p className="h5">{!customer_closed_on && is_current && can_invite?<ReactBootstrap.Button size={"sm"} variant={"danger"}
                                                                                                 onClick={markClose} >Close Customer</ReactBootstrap.Button>:""}</p>

                  <p className="h5">
                    {category}
                  </p>
                  <p className="font-weight-light h5">{email}</p>
                  <p className="font-weight-light h5">{contact_number}</p>
                  {distance_from_organization && (
                    <p className="font-weight-light h5">
                      {distance_from_organization} meters away
                    </p>
                  )}
                </div>
              </td>
            </tr>
          </table>
        </p>
      </ReactBootstrap.Col>
      <ReactBootstrap.Col
        style={{
          paddingTop: '20px',
        }}
        xs={1}
      >
        {actionFormatter()}
      </ReactBootstrap.Col>
    </ReactBootstrap.Row>
  )
}
